import { z } from 'zod';

export const feedbackSearchSchema = z.object({
  status: z
    .enum(['pending', 'processing', 'resolved', 'closed'])
    .optional()
    .catch(undefined),
});
